import { defineMessages } from 'react-intl';

const messages = defineMessages({
  tableOfContents: {
    id: 'HelpTableOfContents.TableOfContents',
    defaultMessage: 'Table of Contents',
  },
});

export default messages;
